import React from 'react';
import { useNavigate } from 'react-router-dom';
import usePageTitle from '../hooks/usePageTitle';
import MarketShell from '../components/market/MarketShell';
import AddressBook from '../components/market/AddressBook';

// /market/addresses — the customer's saved delivery addresses: add, edit,
// delete, choose the default. Signed-in only; RLS keeps each customer to their own.
const T = {
  ar: { market: 'السوق', title: 'عناويني', lead: 'عناوين التوصيل المحفوظة. تعديلها أو حذفها لا يغيّر الطلبات السابقة.', signIn: 'سجّل الدخول لإدارة عناوينك.', login: 'دخول التجار' },
  en: { market: 'Market', title: 'My addresses', lead: 'Your saved delivery addresses. Editing or deleting one never changes past orders.', signIn: 'Sign in to manage your addresses.', login: 'Trader login' },
};
T.zh = T.en;

export default function MarketAddresses({ lang = 'ar', user }) {
  const nav = useNavigate();
  const c = T[lang] || T.ar;
  usePageTitle('market', lang);
  return (
    <MarketShell lang={lang} user={user}>
      <div className="mk-wrap" style={{ paddingBottom: 48, maxWidth: 820 }}>
        <div className="mk-crumbs" aria-label="breadcrumb">
          <button type="button" onClick={() => nav('/market')}>{c.market}</button><span aria-hidden="true">›</span><span aria-current="page">{c.title}</span>
        </div>
        <div className="mk-listing-head"><h1>{c.title}</h1></div>
        <p className="mk-note" style={{ marginTop: 0 }}>{c.lead}</p>
        {user ? <AddressBook user={user} lang={lang} mode="manage" />
          : <p className="mk-empty" data-addresses-signin="1">{c.signIn} <button type="button" className="mk-more" onClick={() => nav('/login/buyer')}>{c.login}</button></p>}
      </div>
    </MarketShell>
  );
}
